const Contact = () => {
  return (
    <div className="contact">
      <h1>Martin Mircea Ioan</h1>
      <a href="tel: +436889213814"> ☎ AT +43 6889213814 </a>
        <a href="tel: +40742884593"> ☎ RO +40 742884593 </a>
      <a href="mailto: mirceamartinioan@gmail.com">✉ mirceamartinioan@gmail.com </a>
    </div>
  );
};

export default Contact;
